/**
 * Documents API
 * All document-related API calls
 */

import { apiClient } from './config';

/**
 * Fetch patient documents
 */
export const fetchPatientDocuments = async (patientId) => {
  const response = await apiClient.get(`/fetch-files/${patientId}`);
  return {
    patientId,
    files: response.data.files || [],
  };
};

/**
 * Fetch patients with pending document approvals
 */
export const fetchPendingApprovals = async () => {
  const response = await apiClient.get('/patients-with-pending-approvals');
  return {
    patients: response.data.patients || [],
    totalCount: response.data.totalCount || 0,
  };
};

/**
 * Fetch general pending documents
 */
export const fetchGeneralPendingDocuments = async () => {
  const response = await apiClient.get('/patients-with-pending-approvals-general');
  return {
    documents: response.data.documents || [],
    totalCount: response.data.totalCount || 0,
  };
};

/**
 * Fetch documents for approval by patient
 */
export const fetchDocumentsForApproval = async (patientId) => {
  const response = await apiClient.get(`/documentsApproval/${patientId}`);
  return {
    files: response.data.files || [],
    isSubmitted: response.data.isSubmitted || false,
  };
};

/**
 * Update document filename
 */
export const updateDocumentFilename = async (patientId, fileId, fileName) => {
  const response = await apiClient.patch(
    `/documentsApproval/${patientId}/files/${fileId}`,
    { newFilename: fileName }
  );
  return response.data;
};

/**
 * Approve document
 */
export const approveDocument = async (patientId, fileId) => {
  const response = await apiClient.post(`/documents/${patientId}/approve/${fileId}`);
  return response.data;
};

/**
 * Reject document
 */
export const rejectDocument = async (patientId, fileId, reason) => {
  const response = await apiClient.post(`/documents/${patientId}/reject/${fileId}`, {
    reason,
  });
  return response.data;
};

/**
 * Update document submission status
 */
export const updateDocumentSubmissionStatus = async (patientId, isSubmitted) => {
  const response = await apiClient.patch(`/documents-approval/${patientId}/submit`, {
    isSubmitted,
  });
  return response.data;
};
